import services from "../services/services";
import { requestObject } from "./requestObject";
var GetVehicleType=(setVehicles)=>
{
    
     //////////////////////////getstate////////////////////////////
           var statereq=
            {
                
            };


               
         // const requestOptions = 
         // {
         //    method: 'POST',
         //    headers: { 'Content-Type': 'application/json'
         //             },
                     
         //       body: JSON.stringify(statereq)
         // };

         var requestOptions=requestObject.RequestHeader(statereq);

         services.getVehicles(requestOptions).then((res) => 
         {
            setVehicles(res.rows);
         });
    

}


export default GetVehicleType;